/**
 * jQuery-free call tracking library.
 *
 * Initialize after TrimarkSourceTracker:
 * window.TrimarkCallTracker.init({
 *   swap: '(555) 555-5555',
 *   default: '(555) 555-1234',
 *   triggers: {
 *     src: {
 *       g: { phone: '(555) 555-9876', name: 'Google' },
 *     },
 *   },
 *   afterHours: {
 *     phone: '(555) 555-0000',
 *     timeZone: 'America/New_York',
 *     businessHours: [{ days: [1, 2, 3, 4, 5], start: '08:00', end: '17:00' }],
 *   },
 * });
 */
(function () {
	var CallTracker = function () {
		// Each anchor is rendered from its as-published markup, so a later update
		// can swap in a different number or put the original one back.
		var originals = new WeakMap();

		return {
			settings: {},
			schedule: [],
			boundaryTimer: null,
			init: function (settings) {
				if (typeof TrimarkSourceTracker === 'undefined') {
					console.warn('TrimarkSourceTracker is not initialized. CallTracker cannot function without it.');
					return;
				}

				this.settings = settings;
				this.schedule = settings.afterHours
					? TrimarkBusinessHours.normalize(settings.afterHours.businessHours)
					: [];

				this.updatePhones();
				this.watchBusinessHours();
			},
			getCallTrackingPhone: function () {
				var sourceCookie = TrimarkSourceTracker.getSourceData();
				var triggers = this.settings.triggers || {};
				var targetPhone = '';

				var triggerKeys = Object.keys(triggers);
				for (var i = 0; i < triggerKeys.length; i++) {
					var trigger = triggerKeys[i];
					if (sourceCookie.hasOwnProperty(trigger)) {
						// Case-insensitive match — same fix as assets-legacy/js/call-tracker.js.
						var cookieVal = String(sourceCookie[trigger]).toLowerCase();
						Object.keys(triggers[trigger]).forEach(function (key) {
							if (key.toLowerCase() === cookieVal) {
								targetPhone = triggers[trigger][key].phone;
							}
						});
						break;
					}
				}

				return targetPhone;
			},
			isAfterHours: function () {
				var afterHours = this.settings.afterHours;

				if (!afterHours || !afterHours.phone || !this.schedule.length) {
					return false;
				}

				// A null result means the timezone could not be read, in which case
				// the published number stands.
				return TrimarkBusinessHours.isOpen(this.schedule, afterHours.timeZone, new Date()) === false;
			},
			getTargetPhone: function () {
				if (this.isAfterHours()) {
					return this.settings.afterHours.phone;
				}

				var phone = this.getCallTrackingPhone();

				if (Cookies.get('trmk_is_paid') && phone === '') {
					phone = this.settings.default || '';
				}

				return phone;
			},
			updatePhones: function () {
				var swap = this.settings.swap;

				if (!swap) {
					return;
				}

				var phone = this.getTargetPhone();
				var telHref = phone ? 'tel:' + phone.replace(/\D/g, '') : null;

				var anchors = document.querySelectorAll('a');
				Array.prototype.forEach.call(anchors, function (el) {
					var original = originals.get(el);

					if (!original) {
						if (el.innerHTML.indexOf(swap) === -1) {
							return;
						}

						original = { html: el.innerHTML, href: el.getAttribute('href') };
						originals.set(el, original);
					}

					var html = phone ? original.html.split(swap).join(phone) : original.html;
					var href = telHref === null ? original.href : telHref;

					if (el.innerHTML !== html) {
						el.innerHTML = html;
					}

					if (href === null) {
						el.removeAttribute('href');
					} else if (el.getAttribute('href') !== href) {
						el.setAttribute('href', href);
					}
				});
			},
			watchBusinessHours: function () {
				var self = this;
				var afterHours = this.settings.afterHours;

				if (!afterHours || !this.schedule.length) {
					return;
				}

				var queueNextBoundary = function () {
					window.clearTimeout(self.boundaryTimer);

					var minutes = TrimarkBusinessHours.minutesUntilChange(
						self.schedule,
						afterHours.timeZone,
						new Date()
					);

					if (minutes === null) {
						return;
					}

					self.boundaryTimer = window.setTimeout(function () {
						self.updatePhones();
						queueNextBoundary();
					}, minutes * 60000 + 1000);
				};

				queueNextBoundary();

				// A backgrounded tab can have its timer throttled past the boundary.
				document.addEventListener('visibilitychange', function () {
					if (document.hidden) {
						return;
					}

					self.updatePhones();
					queueNextBoundary();
				});
			},
		};
	};

	window.TrimarkCallTracker = CallTracker();
})();
